import { gql } from "@apollo/client";
import { client } from "graphql/client";

export const VIEW_DRIVER_PHONE = gql`
    mutation ViewDriverPhone($accountId: Long!) {
        viewDriverPhone(accountId: $accountId)
    }
`;

export interface ViewDriverPhoneResponse {
    viewDriverPhone: string;
}

export interface ViewDriverPhoneVariables {
    accountId: number;
}

export const viewDriverPhone = async (accountId: number): Promise<string> => {
    const { data } = await client.mutate<ViewDriverPhoneResponse, ViewDriverPhoneVariables>({
        mutation: VIEW_DRIVER_PHONE,
        variables: { accountId }
    });
    return data!.viewDriverPhone;
};
